export const NotificationStatus = {
    Draft: 'draft',
    WaitsApproval: 'waits_approval',
    Approved: 'approved',
    Rejected: 'rejected',
};
